import React from 'react';
import { DateTime } from 'luxon';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import CopyrightIcon from '@material-ui/icons/Copyright';
import RemoveRoundedIcon from '@material-ui/icons/RemoveRounded';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: ({ absolute }) => (absolute ? 'absolute' : 'relative'),
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.contrastText,
    width: '100%',
    padding: 8,
    background: theme.palette.primary.main,
    zIndex: 30,
    boxSizing: 'border-box',
    color: 'var(--light-text-color)',
    '& a': {
      color: 'var(--light-text-color)',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      margin: '4px 0',
    },
    '& a:hover': {
      cursor: 'pointer',
      textDecorationLine: 'underline',
    },
    '& svg': {
      marginRight: 4,
    },
  },
  copyrightContainer: {
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    width: 120,
    justifyContent: 'space-between',
  },
  spacer: {
    width: 50,
    color: 'var(--light-text-color)',
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  contactContainer: {
    alignSelf: 'flex-end',
  },
  '@media screen and (max-width: 450px)': {
    root: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    contactContainer: {
      alignSelf: 'unset',
      margin: '0 8px',
    },
    spacer: {
      height: 36,
    },
  },
}));

const Footer = function (props) {
  const classes = useStyles({ absolute: props.absolute });
  const isMobile = window.innerWidth < 768;

  return (
    <div className={classes.root}>
      <div className={classes.contactContainer}>
        <Typography
          color="inherit"
          className={classes.copyrightContainer}
          component="div"
        >
          <CopyrightIcon fontSize="small" /> Jotly, Inc. {DateTime.local().year}
        </Typography>
        <a href="mailto: jotlynotes@gmail.com">jotlynotes@gmail.com</a>
      </div>
      <div className={classes.spacer}>{!isMobile && <RemoveRoundedIcon />}</div>
      <Box display="flex" alignItems="flex-end">
        <Box marginLeft={1} marginRight={1}>
          <b>
            <p>Follow Us</p>
          </b>
          <a href="https://www.instagram.com/jotlynotes">
            <InstagramIcon />
            @jotlynotes
          </a>
          <a href="https://www.twitter.com/jotlynotes">
            <TwitterIcon />
            @jotlynotes
          </a>
        </Box>
        <Box marginLeft={1} marginRight={1}>
          <a href="https://www.youtube.com/channel/UCDZ6oDtivc4KOHRYknuTNkg">
            <YouTubeIcon />
            jotlynotes
          </a>
          <a href="https://www.linkedin.com/company/jotlynotes">
            <LinkedInIcon /> JotlyNotes
          </a>
        </Box>
      </Box>
      <div className={classes.spacer}>{!isMobile && <RemoveRoundedIcon />}</div>
      <Box display="flex" alignItems="flex-end">
        <Box marginLeft={1} marginRight={1}>
          <b>
            <p>Pages</p>
          </b>
          <a href="/signin">Sign In</a>
          <a href="/signup">Sign Up</a>
        </Box>
        <Box marginLeft={1} marginRight={1}>
          <a href="/published">Published</a>
          <a href="/privacy-policy">Privacy Policy</a>
        </Box>
        <Box marginLeft={1} marginRight={1}>
          <a href="/note-conversion">Note Conversion</a>
        </Box>
      </Box>
    </div>
  );
};

export default Footer;
